module.exports = __webpack_public_path__ + "img/3diamond-13.f3902337.svg";